import type { ButtonHTMLAttributes, ReactNode } from "react";

import { Spinner } from "./Spinner";

/**
 * primary: the main action. secondary: everything else. ghost: low-key. danger: removing
 * something (outlined). destructive: final, can't-undo actions (filled).
 */
type Variant = "primary" | "secondary" | "ghost" | "danger" | "destructive";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: "sm" | "md" | "lg";
  loading?: boolean;
  children: ReactNode;
}

/** Disabled while loading so a double click can't send a request twice. */
export function Button({
  variant = "secondary",
  size = "md",
  loading = false,
  disabled,
  type = "button",
  className,
  children,
  ...rest
}: ButtonProps) {
  const classes = ["btn", `btn-${variant}`, size !== "md" ? `btn-${size}` : "", className ?? ""]
    .filter(Boolean)
    .join(" ");
  return (
    <button type={type} className={classes} disabled={disabled || loading} aria-busy={loading || undefined} {...rest}>
      {loading ? <Spinner /> : null}
      {children}
    </button>
  );
}
